import { Grid } from 'ui';
import { Typography } from 'omakase';
import { consumer } from '@tock/coretypes';
import QuizResult from 'components/profile/quiz/QuizResult';

interface Props {
  results: consumer.IPatronQuizResult[];
}

const QuizModalResults = ({ results }: Props) => {
  return (
    <>
      <Typography component="h1" variant="heading02" align="center">
        Your results are in!
        <br />
        You'll be right at home on Tock.
      </Typography>
      <br />
      <Grid container spacing={1}>
        {results.map((result, i) => {
          return (
            <Grid item xs={12}>
              <QuizResult
                label={i === 1 ? 'Drink Preferences' : undefined}
                layout="modal"
                result={result}
                key={`quiz-result-${result.id}`}
              />
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default QuizModalResults;
